var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpcRatingB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 49,
    fill: "none",
    viewBox: "0 0 52 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2EA949",
    d: "M51.02 24.423c0 2.592-3.226 4.652-3.986 6.991-.76 2.34.583 5.987-.887 8.005-1.469 2.019-5.303 1.824-7.337 3.31-2.036 1.487-2.99 5.177-5.413 5.962-2.424.785-5.295-1.647-7.887-1.647-2.593 0-5.54 2.407-7.887 1.647-2.348-.76-3.378-4.492-5.413-5.962-2.035-1.469-5.852-1.266-7.338-3.31-1.486-2.043-.093-5.573-.886-8.005C3.192 28.982 0 27.014 0 24.423c0-2.593 3.226-4.653 3.986-6.992.76-2.34-.583-5.987.886-8.005 1.47-2.018 5.303-1.824 7.338-3.31C14.245 4.629 15.2.939 17.623.154c2.424-.785 5.294 1.689 7.887 1.689 2.592 0 5.54-2.407 7.887-1.689 2.347.718 3.377 4.492 5.413 5.962 2.034 1.469 5.851 1.266 7.337 3.31 1.487 2.043.093 5.573.887 8.005.794 2.432 3.986 4.4 3.986 6.992Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 17,
    fill: "#fff",
    stroke: "#2EA949",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2EA949",
    d: "M19.898 32V15.195h7.653c1.5 0 2.707.387 3.62 1.16.915.797 1.372 1.868 1.372 3.211 0 1.602-.582 2.747-1.746 3.434v.094c1.578.734 2.367 2.086 2.367 4.054 0 1.524-.469 2.707-1.406 3.551-.961.867-2.274 1.301-3.938 1.301h-7.922Zm3.258-10.102h3.867c.735 0 1.278-.175 1.63-.527.367-.344.55-.816.55-1.418 0-1.234-.703-1.851-2.11-1.851h-3.937v3.796Zm0 7.172h4.16c.844 0 1.465-.199 1.864-.597.422-.399.633-.926.633-1.582 0-.618-.211-1.137-.633-1.559-.407-.406-1.028-.61-1.864-.61h-4.16v4.348Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpcRatingB);
export default __webpack_public_path__ + "static/media/epcRatingB.c787dbc4.svg";
export { ForwardRef as ReactComponent };